export default "__VITE_ASSET__DxPYUvW6__"